import React from "react";
import {HeadingText} from "../../components/base/typography/HeadingText.jsx";
import {PageLayout} from "../../components/layout/Page/PageLayout.jsx";
import {Paragraph} from "../../components/base/typography/Paragraph.jsx";
import {InlineText} from "../../components/base/typography/InlineText.jsx";
import {GridContainerFlex} from "../../components/layout/GridFlex/GridContainerFlex/GridContainerFlex.jsx";
import {GridItemFlex} from "../../components/layout/GridFlex/GridItemFlex/GridItemFlex.jsx";

export const About = () => {

    return (
        <PageLayout>
            <GridContainerFlex>
                <GridItemFlex>
                    <HeadingText type={"h2"}>I am a a header</HeadingText>
                    <Paragraph>I am a paragraph</Paragraph>
                    <Paragraph fontWeight={"bold"}>I am a bold paragraph</Paragraph>
                    <InlineText>I am inline</InlineText>
                    <InlineText fontWeight={"bold"} style={{fontStyle: "italic"}}> I am also inline</InlineText>
                </GridItemFlex>
            </GridContainerFlex>
        </PageLayout>
    );
};
